import { http } from '@/utils';
import type { RequestOptions } from '@/utils';

// ==================== API Endpoints ====================
// Note: URLs are relative paths, API_PREFIX will be added automatically by http util
const Api = {
    ListContract: '/ListContract',
    AddContract: '/AddContract',
    SaveContract: '/SaveContract',
    DeleteContract: '/DeleteContract',
    FindContract: '/FindContract',
    GetContractDetail: '/GetContractDetail',
    ListContractNode: '/ListContractNode',
    AddContractNode: '/AddContractNode',
    SaveContractNode: '/SaveContractNode',
    DeleteContractNode: '/DeleteContractNode',
    ListContractPay: '/ListContractPay',
    AddContractPay: '/AddContractPay',
    SaveContractPay: '/SaveContractPay',
    DeleteContractPay: '/DeleteContractPay',
};

// ==================== Contract APIs ====================

export async function listContract(
    options?: RequestOptions
): Promise<{
    data: API.Contract[];
    success: boolean;
}> {
    const response = await http.get<{ Contracts: API.Contract[] }>(Api.ListContract, options);
    return {
        data: response.Data.Contracts || [],
        success: true
    };
}

export async function addContract(params: API.Contract): Promise<void> {
    const response = await http.post(Api.AddContract, params);
    if (response.Code !== 200) {
        throw new Error(response.Message);
    }
}

export async function saveContract(params: API.Contract): Promise<void> {
    const response = await http.post(Api.SaveContract, params);
    if (response.Code !== 200) {
        throw new Error(response.Message);
    }
}

export async function deleteContract(params: API.Contract): Promise<void> {
    const response = await http.post(Api.DeleteContract, params);
    if (response.Code !== 200) {
        throw new Error(response.Message);
    }
}

export async function findContract(params: API.FindContractReq): Promise<API.FindContractRsp> {
    const response = await http.post(Api.FindContract, params);
    return response.Data;
}

export async function getContractDetail(params: { ID: number }): Promise<{data: API.Contract;}> {
    const response = await http.post<API.Contract>(Api.GetContractDetail, params);
    return {
        data: response.Data || {},
    };
}

export async function listContractNode(params: { ContractID: number }): Promise<API.ContractNode[]> {
    const response = await http.post<{ Nodes: API.ContractNode[] }>(Api.ListContractNode, params);
    return response.Data.Nodes || [];
}

export async function addContractNode(params: {
    ContractID: number;
    NodeName: string;
    Status: number;
    StartTime: string;
    ExpectedEndTime: string;
    Resources: string[];
}): Promise<void> {
    const response = await http.post(Api.AddContractNode, params);
    if (response.Code !== 200) {
        throw new Error(response.Message);
    }
}

export async function saveContractNode(params: {
    ID: number;
    ContractID: number;
    NodeName: string;
    Status: number;
    StartTime: string;
    ExpectedEndTime: string;
    Resources: string[];
}): Promise<void> {
    const response = await http.post(Api.SaveContractNode, params);
    if (response.Code !== 200) {
        throw new Error(response.Message);
    }
}

export async function deleteContractNode(params: { ID: number }): Promise<void> {
    const response = await http.post(Api.DeleteContractNode, params);
    if (response.Code !== 200) {
        throw new Error(response.Message);
    }
}

// ==================== Contract Pay APIs ====================

export async function listContractPay(params: { ContractID: number }): Promise<API.ContractPay[]> {
    const response = await http.post<{ Pays: API.ContractPay[] }>(Api.ListContractPay, params);
    return response.Data.Pays || [];
}

export async function addContractPay(params: {
    ContractID: number;
    Name: string;
    PayerName: string;
    PayerPhone: string;
    PaymentAmount: number;
    Status: number;
    PeriodName: string;
    PeriodNo: number;
    Resources: string[];
}): Promise<void> {
    const response = await http.post(Api.AddContractPay, params);
    if (response.Code !== 200) {
        throw new Error(response.Message);
    }
}

export async function saveContractPay(params: {
    ID: number;
    ContractID: number;
    Name: string;
    PayerName: string;
    PayerPhone: string;
    PaymentAmount: number;
    Status: number;
    PeriodName: string;
    PeriodNo: number;
    Resources: string[];
}): Promise<void> {
    const response = await http.post(Api.SaveContractPay, params);
    if (response.Code !== 200) {
        throw new Error(response.Message);
    }
}

export async function deleteContractPay(params: { ID: number }): Promise<void> {
    const response = await http.post(Api.DeleteContractPay, params);
    if (response.Code !== 200) {
        throw new Error(response.Message);
    }
}
